import { useLocation } from '@reach/router'
import { useMobile } from 'src/hooks/useMobile'
import { Image } from 'src/components/ui/Image'
import Skeleton from 'react-loading-skeleton'
import { useDiscountStripeContext } from 'src/components/contexts/DiscountStripeContext'
import type { StripeDataType } from 'src/cms/hooks/getProductStripeData'

const doNotShowUrls = ['cartao-presente']

type ProductStripeProps = {
  stripeData?: StripeDataType | null
}

export const ProductStripe = ({
  stripeData: componentStripeData,
}: ProductStripeProps) => {
  const { stripeData: contextStripeData } = useDiscountStripeContext()

  const stripeData = componentStripeData ?? contextStripeData

  const { pathname } = useLocation()
  const { isMobile, screenWidth } = useMobile()

  const isHidden = doNotShowUrls.some((url) => {
    return pathname.includes(url)
  })

  if (isHidden || !stripeData?.enable) {
    return null
  }

  if (isMobile === undefined) {
    return <Skeleton width="100%" height="80px" />
  }

  const { banner } = stripeData

  const src = isMobile
    ? banner.mobile
    : screenWidth < 1440
    ? banner.tablet
    : banner.desktop

  const height = isMobile ? 88 : 80

  return (
    <div>
      <Image className="w-full" src={src} width={screenWidth} height={height} />
    </div>
  )
}
